import { useEffect, useState } from "react";
import { CopyBlock } from "react-code-blocks";

const CodeBlock = ({ block }) => {
  const content = block.content;
  const isNewFormat = Array.isArray(content) && content[0].fileRef;
  const isInlineCode = Array.isArray(content) && content[0].code;

  const [selectedTab, setSelectedTab] = useState(
    isNewFormat ? content[0].fileRef : isInlineCode ? content[0].language : ""
  );
  const [displayedCode, setDisplayedCode] = useState(
    isInlineCode ? content[0].code : ""
  );
  const [title, setTitle] = useState(block.title || "");

  const handleTabChange = (value) => {
    setSelectedTab(value);

    if (isInlineCode) {
      const selectedTabContent = content.find((item) => item.language === value);
      if (selectedTabContent) {
        setDisplayedCode(selectedTabContent.code);
      }
    }
  };

  useEffect(() => {
    if (isNewFormat) {
      const readCodeFromFile = (fileRef) => {
        fetch(`./code/` + fileRef)
          .then((response) => {
            return response.text();
          })
          .then((fileContent) => {
            setDisplayedCode(fileContent);
          })
          .catch((error) => {
            console.error("Error loading code file:", error);
            setDisplayedCode("// Error loading code file");
          });
      };

      readCodeFromFile(selectedTab);
    }
  }, [selectedTab, isNewFormat]);

  return (
    <div className="code-block">
      {title && <div className="code-block-title">{title}</div>}

      {(isNewFormat || isInlineCode) && (
        <>
          <div className="code-block-tabs">
            {content.map((codeBlock, index) => (
              <button
                key={index}
                className={`code-block-tab ${
                  selectedTab === (isNewFormat ? codeBlock.fileRef : codeBlock.language)
                    ? "code-block-tab-active"
                    : ""
                }`}
                onClick={() =>
                  handleTabChange(isNewFormat ? codeBlock.fileRef : codeBlock.language)
                }
              >
                {codeBlock.language}
              </button>
            ))}
          </div>

          <div className="code-block-content-wrapper">
            <CopyBlock
              language={
                content.find(
                  (c) =>
                    (isNewFormat ? c.fileRef : c.language) === selectedTab
                )?.language || content[0].language
              }
              text={displayedCode}
              theme={"a11yLight"}
              customStyle={{
                borderRadius: 0,
                minHeight: "80px",
                backgroundColor: "var(--color-lightgrey1)",
                paddingLeft: 10,
              }}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default CodeBlock;